// extracted by mini-css-extract-plugin
module.exports = {"ShortListTable":"ShortListTable_ShortListTable__ODzsP","criteria":"ShortListTable_criteria__uDNEh","more":"ShortListTable_more__1aCQO"};